import type { PinterestAdGroupEntry, PinterestCampaignWithAdGroups } from '../api/types';

export interface PinterestCampaignRow extends PinterestCampaignWithAdGroups {
  isAdGroup?: false;
}

export interface PinterestAdGroupRow extends PinterestAdGroupEntry {
  campaign_id: string;
  campaign_name: string;
  account_id: string;
  isAdGroup: true;
}

export type PinterestGridRow = PinterestCampaignRow | PinterestAdGroupRow;

export const isPinterestAdGroupRow = (row: PinterestGridRow): row is PinterestAdGroupRow =>
  row.isAdGroup === true;

export const getPinterestGridRowId = (row: PinterestGridRow): string =>
  isPinterestAdGroupRow(row) ? row.ad_group_id : row.campaign_id;
